import Button from "components/Button";

export const NoSpaces = ({ href }: { href: string }) => {
  return (
    <div className="flex flex-1 items-center justify-center bg-white">
      <div className="flex min-h-[200px] flex-col items-center justify-center">
        <span className="text-24px">区画と利用状況を登録してください</span>
        <span className="pt-2 text-[13.71px]">区画を登録して、利用中の場合は利用状況を入力してください</span>
        <div className="mt-[24px] w-[160px]">
          <Button text={"区画を新規登録"} href={href} />
        </div>
      </div>
    </div>
  );
};
